var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.5 3a2 2 0 0 1 2 2v2a2 2 0 0 1-1.018 1.743q.018.126.018.257v10c0 1.105-.951 2-2.125 2H5.625C4.451 21 3.5 20.105 3.5 19V9q0-.131.018-.258A2 2 0 0 1 2.5 7V5a2 2 0 0 1 2-2zm-1 6h-13v10h13zM13 11a1 1 0 0 1 0 2h-2a1 1 0 1 1 0-2zm6.5-6h-15v2h15z"
})));
export default SvgGemArchive;